import { useEffect } from "react";

export default function CTraderPopupCallback() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const payload = {
        type: "CTRADER_AUTH_DONE",
        tempId: params.get("ctrader_temp_id") || params.get("temp_id") || params.get("state"),
        state: params.get("state"),
        code: params.get("code"),
      };
      // Write to storage to notify opener via 'storage' event as a robust fallback
      try {
        if (payload.tempId) {
          localStorage.setItem("ctrader_callback_temp_id", String(payload.tempId));
        }
      } catch { /* noop */ }
      if (window.opener && payload.tempId) {
        // Post back to our parent origin and close
        window.opener.postMessage(payload, window.location.origin);
        window.close();
      }
    } catch {
      // ignore; fallback text remains
    }
  }, []);

  return (
    <div style={{ padding: 16, fontFamily: 'sans-serif' }}>
  You can close this window.
    </div>
  );
}